/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {AudioListener} from '@wonderlandengine/components';
import {AudioSource} from '@wonderlandengine/components';
import {VoxelBullet} from './bullet.js';
import {FpsPistol} from './fps-pistol.js';
import {GameLoop} from './game-loop.js';
import {MiningTool} from './mining-tool.js';
import {NavManager} from './nav-manager.js';
import {PlayerInput} from './player-input.js';
import {RemotePlayerManager} from './remote-player-manager.js';
import {VoxelTreadmill} from './stream.js';
import {TextMenuHud} from './text-menu-hud.js';
import {TreeHandler} from './tree-handler.js';
import {VRControls} from './vr-controls.js';
import {WaterSurface} from './water-surface.js';
import {ZombieBot} from './zombie-bot.js';
/* wle:auto-imports:end */

export default function(engine) {
/* wle:auto-register:start */
engine.registerComponent(AudioListener);
engine.registerComponent(AudioSource);
engine.registerComponent(VoxelBullet);
engine.registerComponent(FpsPistol);
engine.registerComponent(GameLoop);
engine.registerComponent(MiningTool);
engine.registerComponent(NavManager);
engine.registerComponent(PlayerInput);
engine.registerComponent(RemotePlayerManager);
engine.registerComponent(VoxelTreadmill);
engine.registerComponent(TextMenuHud);
engine.registerComponent(TreeHandler);
engine.registerComponent(VRControls);
engine.registerComponent(WaterSurface);
engine.registerComponent(ZombieBot);
/* wle:auto-register:end */
}
